import { render, staticRenderFns } from "./ColaboradoresModal.vue?vue&type=template&id=36d8f1c8"
import script from "./ColaboradoresModal.vue?vue&type=script&lang=js"
export * from "./ColaboradoresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports